import { render, staticRenderFns } from "./dashAd.vue?vue&type=template&id=366474a0&scoped=true&"
import script from "./dashAd.vue?vue&type=script&lang=js&"
export * from "./dashAd.vue?vue&type=script&lang=js&"
import style0 from "./dashAd.vue?vue&type=style&index=0&id=366474a0&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366474a0",
  null
  
)

export default component.exports